const ActiveSubmissionDropdownComponent = {
    templateUrl: '/activeSubmissionDropdown/activeSubmissionDropdown.tpl.html',
    controller: 'activeSubmissionDropdownController',
    bindings: {}
};

angular.module('gw-um-submission')
    .component('activeSubmissionDropdown', ActiveSubmissionDropdownComponent);
